import type { RequestInfo } from '@warp-drive/core/types/request';
import { buildBaseURL, type QueryUrlOptions } from '@warp-drive/utilities';
import { SkipCache } from '@warp-drive/core-types/request';

/** PATCH /match-payments/certify — certify a batch of match payments. */
export function certifyMatchPaymentsRequest(matchPaymentIds: string[]): RequestInfo {
  const opts: QueryUrlOptions = {
    identifier: { type: 'match-payments' },
    op: 'query',
    resourcePath: 'match-payments',
  };
  return {
    url: `${buildBaseURL(opts)}/certify`,
    method: 'PATCH',
    body: JSON.stringify({ match_payment_ids: matchPaymentIds }),
    cacheOptions: { [SkipCache]: true },
  };
}
